import React from 'react';
import PropTypes from 'prop-types';

import AddTablesForm from '../AddTablesForm/AddTablesForm';

const SingleEventForm = ({ createChart, event }) => {
  const { name, id } = event;
  const handleCreateChart = tables => createChart({ name, event_id: id }, tables);

  return (
    <div className="seating-create-modal single-event">
      <h1 className="h1">Welcome to Your Seating Chart!</h1>
      <p className="create__subtitle">We&apos;ll add you to the first table for your <strong>{name}</strong>. Add more tables to get started!</p>
      <div className="single-event__form">
        <AddTablesForm createChart={handleCreateChart} />
      </div>
    </div>
  );
}
SingleEventForm.propTypes = {
  createChart: PropTypes.func.isRequired,
  event: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  }),
};

export default SingleEventForm;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ChartCreator/SingleEventForm/SingleEventForm.jsx